import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Routes from "./routers";
import withTracker from "./withTracker";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import { PersistGate } from "redux-persist/es/integration/react";
import { Provider } from "react-redux";
import configureStore from "./config";
import history from "./history";
import LoaderUI from "./components/common/loader";
import { socket, backendSocket, SocketContext } from "./context/actions/socket";
import { InpleoI18nProvider } from "./components/i18n/Inpleoi18n";
import { I18nProvider } from "./components/i18n/i18nProvider";
import Unauthorized from "./components/common/Unauthorized";
import { roleItems } from "./utils/constants";
import  'bootstrap/dist/js/bootstrap.bundle';
// import io from 'socket.io-client';
// import { socketUrlBackend, socketUrl } from "./environment";
const App = () => {
  console.log("console =>", socket, backendSocket);

  /************ store configration *********/
  const { persistor, store } = configureStore(history);

  // const socket = io(socketUrlBackend);
  // const socketKafka = io(socketUrl);
  // window.socket = socketKafka;
  // window.socket = socket;
  return (
    <InpleoI18nProvider>
      <Provider store={store}>
        <PersistGate loading={<LoaderUI />} persistor={persistor}>
          <Router basename={process.env.REACT_APP_BASENAME}>
            <I18nProvider>
              <div className="main_root">
                <SocketContext.Provider value={{ socket, backendSocket }}>
                  <Switch>
                    {Routes.map((route, index) => {
                      const { role, roleType, permissions } = route;

                      return (
                        <Route
                          key={index}
                          path={route.path}
                          exact={route.exact}
                          component={withTracker((props) => {
                            const { user } = store.getState();

                            const userRole = user?.user?.role;

                            // if (userRole != roleItems[2]) {
                              if (
                                (!role || role.includes(userRole)) &&
                                (!roleType ||
                                  user?.user?.roles?.role?.type === roleType) &&
                                (!permissions ||
                                  user?.user?.roles?.permissions?.some((item) =>
                                    permissions.includes(item.SLUG)
                                  ))
                              ) {
                                return (
                                  <route.layout {...props}>
                                    <route.component {...props} />
                                  </route.layout>
                                );
                              } else {
                                return <Unauthorized />;
                              }
                            // } else {
                            //   return (
                            //     <route.layout {...props}>
                            //       <route.component {...props} />
                            //     </route.layout>
                            //   );
                            // }
                          })}
                        />
                      );
                    })}
                  </Switch>
                </SocketContext.Provider>
              </div>
            </I18nProvider>
          </Router>
        </PersistGate>
      </Provider>
    </InpleoI18nProvider>
  );
};

export default App;
